<template lang="pug">
  div(v-if="hydrated")
    template(v-if='loading')
      v-app
        v-app-bar(app, color="blue-grey", dense, dark, :clipped-left="$vuetify.breakpoint.lgAndUp")
          v-toolbar-title {{sheet_version[1]}} 資料更新中...
        v-main
          v-progress-linear(color='blue-grey lighten-5' indeterminate rounded height="100")
    template(v-else)
      router-view      
</template>

<script>
import { mapGetters } from 'vuex'
import sheet_update from './mixins/sheet_update'
export default {
  name: 'App',
  mixins: [sheet_update],
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({ hydrated: 'hydrated' })
  },
  async mounted() {
    if (this.isOnline) {
      await this.update_version()
      if (this.sheet_version[0] != this.sheet_version[1]) {
        this.loading = true
        await this.update_bird_list()
        await this.update_family_list()
        await this.update_bbs_birds()
        await this.update_bbs_plot()
        await this.update_bbs_history_birds()
        this.$offlineStorage.set('version', this.sheet_version[1])
        this.loading = false
      }
    }
  }
}
</script>
